module.exports = __webpack_public_path__ + "img/transportation.af44ad77.svg";